export const ADMIN = 'ADMIN';
export const SUPER_ADMIN = 'SUPER_ADMIN';
export const RESELLER = 'RESELLER';
export const DRIVER = 'DRIVER';
export const COMPANY = 'COMPANY';
